import React, { Component } from "react";

import { withAuth } from "../../shared/containers/containerAuth";
import { withSignInForm } from "../../shared/containers/containerSignInForm";

import ButtonPrimary from "../../shared/items/contols/buttonPrimary";
import ButtonSecondary from "../../shared/items/contols/buttonSecondary";
import PreloaderLight from "./../../shared/items/static/preloaderLight";
import { states } from "./../../reducers/queriesStates";

import styles from "./buttonLoginWrapper.module.scss";

const BUTTON_LOGIN_NAME = "Войти";
const BUTTON_LOGIN_DEMO_NAME = "DEMO";

class ButtonLoginWrapper extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.clickEnter);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.clickEnter);
  }

  clickEnter = (e) => {
    const { signInForm, onLogIn } = this.props;

    if (e.keyCode === 13) {
      onLogIn(signInForm.signInItems);
    }
  };

  render() {
    const { signInForm, onLogIn, dataState, onLogInDemo } = this.props;

    return (
      <div>
        <div style={{ marginBottom: "10px" }}>
          <ButtonPrimary handleClick={onLogIn.bind(this, signInForm.signInItems)} disabled={dataState === states.REQUEST}>
            {dataState === states.REQUEST ? (
              <div className={styles.container_preloader}>
                <PreloaderLight />
              </div>
            ) : (
              BUTTON_LOGIN_NAME
            )}
          </ButtonPrimary>
        </div>

        <ButtonSecondary handleClick={onLogInDemo.bind(this, signInForm.signInItems)} disabled={dataState === states.REQUEST}>
          {dataState === states.REQUEST ? (
            <div className={styles.container_preloader}>
              <PreloaderLight />
            </div>
          ) : (
            BUTTON_LOGIN_DEMO_NAME
          )}
        </ButtonSecondary>
      </div>
    );
  }
}

export default withAuth(withSignInForm(ButtonLoginWrapper));
